import React from 'react';
import classNames from 'classnames';

import styles from '../styles/Instructions.css';

export default (props) => {
  return (
    <div className={styles.instructionScreen}>
      <h1 className={styles.title}>Instructions</h1>
      <div className={styles.body}>{props.text.split("\n").map(t => <p>{t}</p>)}</div>
      <a className={styles.backBtn} onClick={()=>props.onBackBtn()}>Back</a>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Instructions.js